import React from "react";
import {
  // HashRouter as Router,
  BrowserRouter,
  HashRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MainLayout from "../components/layouts/main-layout";
import { ToastContainer } from "react-toastify";
import AddCustomer from "../modules/customer-information/add-customer";
import AdminAddCustomer from "../modules/customer-admin/add-customer";
import CustomerTable from "../modules/customer-information/customer-table";
import AddProduct from "../modules/products/add-product";
import ProductTable from "../modules/products/product-table";
import UserLogin from "../modules/login/user-login";
import ForgotPassword from "../modules/login/forgot-password";
import PasswordReset from "../modules/login/password-reset";
import ViewCustomer from "../modules/customer-information/customer-view";
import EditCustomer from "../modules/customer-information/customer-edit";
import ViewProduct from "../modules/products/view-product";
import EditProduct from "../modules/products/edit-product";
import ErrorBoundary from "../components/layouts/error-boundary";
import AddStore from "../modules/store-information/add-store";
import StoreTable from "../modules/store-information/store-table";
import EditStore from "../modules/store-information/edit-store";
import ViewStore from "../modules/store-information/view-store";
import PrivateRoute from "./private-route";
import ProtectedRoute from "./protected-route";
import AddUser from "../modules/users/add-user";
import UserTable from "../modules/users/user-table";
import ViewUser from "../modules/users/user-view";
import EditUser from "../modules/users/user-edit";
import AdminCustomerTable from "../modules/customer-admin/customer-table";
import AdminEditCustomer from "../modules/customer-admin/edit-customer";
import AdminViewCustomer from "../modules/customer-admin/view-customer";
import PriceListTable from "../modules/discounts/price-lists/price-list-table";
import AddPriceList from "../modules/discounts/price-lists/add-price-list";
import EditPriceList from "../modules/discounts/price-lists/edit-price-list";
import DiscountGroup from "../modules/discounts/discount-group/discount-group";
import InventoryBase from "../modules/inventory/inventory-base";
import BinLocationManagement from "../modules/inventory/bin-location-management";
import CreateWarehouse from "../modules/inventory/create-warehouse";
import {
  RegionalRestrictionsTable,
  AddRegionalRestriction,
  ViewRegionalRestriction,
} from "../modules/inventory/regional-restrictions";
import PeriodVolumeDiscounts from "../modules/discounts/period-volume-discounts/period-volume-discounts";
import UnderDevelopment from "../modules/under-development";
import StoreExecutionTable from "../modules/store-execution/store-execution-table";
import EditStoreExecution from "../modules/store-execution/edit-store-execution";
import AddSales from "../modules/sales-section/sales-order/add-sales";
import SalesTable from "../modules/sales-section/sales-order/sales-table";
import GoodsReceipt from "../modules/purchase-order/goods-receipt/goods-receipt";
import GoodsTable from "../modules/purchase-order/goods-receipt/goods-table";
import SalesDeliveyTable from "../modules/sales-section/sales-delivery/sales-delivery-table";
import ChartOfAccount from "../modules/accounts/chart-of-accounts";
import GlAccountAllocation from "../modules/accounts/g-l-acc-allocation";
import JournalEntry from "../modules/accounts/journal-entry";
import JournalTable from "../modules/accounts/journal-table";
import SalesInvoice from "../modules/sales-section/sales-invoice/sales-invoice";
import AddSalesInvoice from "../modules/sales-section/sales-invoice/add-sales-invoice";
import AddDelivery from "../modules/sales-section/sales-delivery/add-delivery";
import SalesReturn from "../modules/sales-section/sales-return/sales-return";
import AddSalesReturn from "../modules/sales-section/sales-return/add-sales-return";
import AddSalesPaymentIn from "../modules/sales-section/sales-payment-in/add-sales-payment-in";
import AddPurchaseInvoice from "../modules/purchase-order/purchase-invoice/add-purchase-invoice";
import Settings from "../modules/settings/settings-main-page";
import SalesCreditNote from "../modules/sales-section/sales-credit-note/sales-credit-note";
import AddSalesCreditNote from "../modules/sales-section/sales-credit-note/add-sales-credit-note";
import SalesCreditView from "../modules/sales-section/sales-credit-note/sales-credit-note-view";
import SalesOrderView from "../modules/sales-section/sales-order/sales-view";
import SalesOrderEdit from "../modules/sales-section/sales-order/sales-edit";
import ViewDelivery from "../modules/sales-section/sales-delivery/view-delivery";
import AddPurchase from "../modules/purchase-order/purchase-order/add-purchase";
import PurchaseTable from "../modules/purchase-order/purchase-order/purchase-table";
import ViewPurchase from "../modules/purchase-order/purchase-order/view-purchase";
import EditPurchase from "../modules/purchase-order/purchase-order/edit-purchase";
import ViewGoodsReceipt from "../modules/purchase-order/goods-receipt/view-goods-receipt";
import ViewPurchaseInvoice from "../modules/purchase-order/purchase-invoice/view-purchase-invoice";
import PurchaseInvoiceTable from "../modules/purchase-order/purchase-invoice/purchase-invoice-table";
import PurchaseReturnTable from "../modules/purchase-order/purchase-return/purchase-return-table";
import AddPurchaseReturn from "../modules/purchase-order/purchase-return/add-purchase-return";
import ViewPurchaseReturn from "../modules/purchase-order/purchase-return/view-purchase-return";
import PurchaseCreditTable from "../modules/purchase-order/purchase-credit-note/purchase-credit-table";
import AddPurchaseCredit from "../modules/purchase-order/purchase-credit-note/add-purchase-credit";
import ViewPurchaseCredit from "../modules/purchase-order/purchase-credit-note/view-purchase-credit";
import EditDelivery from "../modules/sales-section/sales-delivery/edit-delivery";
import SalesInvoiceEdit from "../modules/sales-section/sales-invoice/sales-invoice-edit";
import SalesInvoiceView from "../modules/sales-section/sales-invoice/sales-invoice-view";
import SalesReturnView from "../modules/sales-section/sales-return/sales-return-view";
import SalesReturnEdit from "../modules/sales-section/sales-return/sales-return-edit";
import SalesCreditEdit from "../modules/sales-section/sales-credit-note/sales-credit-note-edit";
import EditGoodsReceipt from "../modules/purchase-order/goods-receipt/edit-goods-receipt";
import EditPurchaseInvoice from "../modules/purchase-order/purchase-invoice/edit-purchase-invoice";
import EditPurchaseReturn from "../modules/purchase-order/purchase-return/edit-purchase-return";
import EditPurchaseCredit from "../modules/purchase-order/purchase-credit-note/edit-purchase-credit";
import ViewStoreExecution from "../modules/store-execution/view-store-execution";
import ManufacturerSetup from "../components/settings/data-setup/all-groups/manufacturer-setup";
import ShippingSetup from "../components/settings/data-setup/all-groups/shipping-setup";
import UnitOfMeasure from "../components/settings/data-setup/inventory/unit-of-measure";
import UomGroup from "../components/settings/data-setup/inventory/uom-group";
import ItemSetup from "../components/settings/data-setup/all-groups/item-setup";
import TaxSetup from "../components/settings/data-setup/accounting/taxSetup/tax-setup";
import DocumentNumbering from "../components/settings/system-settings/document-numbering";
import SmtpConfiguration from "../components/settings/communication/smtp/smtp-config";
import SalesPaymentIn from "../modules/sales-section/sales-payment-in/payment-in-table";
import WhatsappConfiguration from "../components/settings/communication/whatsapp/whatsapp-config";
import ViewPaymentIn from "../modules/sales-section/sales-payment-in/view-payment-in";
import PurchasePaymentOut from "../modules/purchase-order/purchase-payment-out/payment-out-table";
import AddPurchasePaymentOut from "../modules/purchase-order/purchase-payment-out/add-sales-payment-out";
import ViewPaymentOut from "../modules/purchase-order/purchase-payment-out/view-payment-out";
import RazorPayConfiguration from "../components/settings/payment/razorpay-config";
import StripeConfiguration from "../components/settings/payment/stripe-config";
import PrintPreference from "../components/settings/print-preference/print-preference";
import AddDoctor from "../modules/doctor-information/add-doctor";
import DoctorTable from "../modules/doctor-information/doctor-table";
import ViewDoctor from "../modules/doctor-information/doctor-view";
import EditDoctor from "../modules/doctor-information/doctor-edit";
import SmsConfiguration from "../components/settings/communication/sms/sms-config";
import PhonePeConfiguration from "../components/settings/payment/phonepe-config";
import PaytmConfiguration from "../components/settings/payment/paytm-config";
import PineLabConfiguration from "../components/settings/payment/pine-lab-config";
import AddStoreTransfer from "../modules/inventory/store-transfer/add-store-transfer";
import OverallSalesReport from "../modules/reports/sales-reports/overall-sales";
import Reports from "../modules/reports/reports-main-page";
import StockTransferTable from "../modules/inventory/store-transfer/stock-transfer-table";
import ViewStockTransfer from "../modules/inventory/store-transfer/view-stock-transfer";
import PaymentModeWiseSalesReport from "../modules/reports/sales-reports/payment-mode-wise-sales";
import DashBoard from "../modules/dashboard/dashboard";
import NewDashboard from "../modules/dashboard/new-dashboard";
import BounceReport from "../modules/reports/inventory-stock-reports/bounce-report";
import BillingTable from "../modules/invoices/billing-table";
import ReturnBillTable from "../modules/return-bill/return-bill-table";
import AddReturnBill from "../modules/return-bill/add-return-bill";
import ViewReturnBill from "../modules/return-bill/view-return-bill";
import BulkPurchaseOrder from "../modules/purchase-order/bulk-purchase-order";
import AlternativeItemSetup from "../components/settings/data-setup/all-groups/alter-item-setup";
import Gstr1Report from "../modules/reports/gst-reports/gst-r-1";
import Gstr2aReport from "../modules/reports/gst-reports/gstr-2a";
import Gstr3aReport from "../modules/reports/gst-reports/gst-hsn-code-report";
import Gstr3bReport from "../modules/reports/gst-reports/gstr-3b";
import Gstr2bReport from "../modules/reports/gst-reports/gst-hsn-code-report";
import GstHsnCodeReport from "../modules/reports/gst-reports/gst-hsn-code-report";
import Gstr9Report from "../modules/reports/gst-reports/gstr-9";
import Gstr9cReport from "../modules/reports/gst-reports/gstr-9c";
import GstItcMisMatchReport from "../modules/reports/gst-reports/itc-mismatch-report";
import GstEwayBillReport from "../modules/reports/gst-reports/gst-e-way-bill-report";
import GstPaymentSummaryReport from "../modules/reports/gst-reports/gst-payment-summary-report";
import GstItcAgingReport from "../modules/reports/gst-reports/itc-aging-report";
import PurchaseOrderCsv from "../modules/purchase-order/purchase-order-csv";
import StockSalesReport from "../modules/reports/inventory-stock-reports/stock-sales-report";
import PurchaseAndReturnReport from "../modules/reports/sales-reports/product-purchase-return";
import SavedReport from "../modules/reports/sales-reports/saved-reports";
import B2bSalesSummary from "../modules/reports/sales-reports/B2bSalesSummary";
import StorePurchase from "../modules/reports/sales-reports/storePurchase";
import EditStockTransfer from "../modules/inventory/store-transfer/edit-stock-transfer";
import TcsTdsSetup from "../components/settings/data-setup/accounting/tcs-tds-setup/tcs-tds-setup";
import ImportTemplates from "../components/settings/data-setup/all-groups/import-templates";
import ExpiryLossReport from "../modules/reports/inventory-stock-reports/expiry-loss-report";
import CustomerPayable from "../modules/reports/inventory-stock-reports/customer-payable";
import ProductInfoReport from "../modules/reports/inventory-stock-reports/product-info";
import GoodsOrderCsv from "../modules/purchase-order/goods-receipt/grn-csv";
import { isAdmin } from "../redux/config";
import PurchaseOrder from "../modules/reports/sales-reports/purchase-order-summary";
import ProfitReport from "../modules/reports/inventory-stock-reports/profits-report";
import VendorMaster from "../modules/reports/inventory-stock-reports/vendor-master";
import StockLedgerBatch from "../modules/reports/inventory-stock-reports/stock-ledger-batch";
import VendorPayable from "../modules/reports/inventory-stock-reports/vendor-payable";
import DayWise from "../modules/reports/sales-reports/day-wise";
import Customization from "../components/settings/user-settings/customization";
import AddBilling from "../modules/invoices/add-billing";
import ReOrder from "../modules/reports/sales-reports/reOrder";
import ViewBilling from "../modules/invoices/view-billing";
import EditBilling from "../modules/invoices/edit-billing";
import StockDetails from "../modules/stock-details";
import StockAuditTable from "../modules/inventory/stock-audit/stock-audit-table";
import EditPaymentOut from "../modules/purchase-order/purchase-payment-out/edit-payment-out";
import AddStockAudit from "../modules/inventory/stock-audit/add-stock-audit";
import ViewStockAudit from "../modules/inventory/stock-audit/view-stock-audit";
import EditStockAudit from "../modules/inventory/stock-audit/edit-stock-audit";
import EditReturnBilling from "../modules/return-bill/edit-return-bill";
import EditPaymentIn from "../modules/sales-section/sales-payment-in/edit-payment-in";
import CustomDocumentNumbering from "../components/settings/system-settings/custom-document-numbering";
import AlertTable from "../modules/alert-management/alert-table";
import ViewAlert from "../modules/alert-management/view-alert";
import EditAlert from "../modules/alert-management/edit-alert";
import AddAlert from "../modules/alert-management/add-alert";
import DepartmentAndRole from "../components/settings/user-settings/department-role";
import ModuleSettings from "../components/settings/system-settings/module-settings";
import AdminAddCustomern from "../modules/customer-admin/add-customern";
import AdminCusCreateEditViewn from "../components/admin-customer/admin-cus-create-edit-viewn";
import AdminCusCreateEditView from "../components/admin-customer/admin-cus-create-edit-view";
import ScheduleDrug from "../components/settings/data-setup/product-info/schedule-drug";
import Lead from "../components/settings/data-setup/product-info/lead";
import Payment from "../components/settings/data-setup/product-info/payment";
import Party from "../components/settings/data-setup/product-info/party";
import Specialization from "../components/settings/data-setup/product-info/specialization";
import Insurance from "../components/settings/data-setup/product-info/insurance";
import AddressSidebar from "../components/common-components/address-bar";
import Composition from "../components/settings/data-setup/product-info/composition";
import InvoiceCustomization from "../components/settings/system-settings/invoice-customization";
import Location from "../components/settings/data-setup/product-info/location";
import PackInfo from "../components/settings/data-setup/product-info/pack-info";
import AddEditUom from "../components/settings/data-setup/inventory/add-edit-uom-group";
import UomGroupAddEdit from "../modules/settings/uom-group-add-edit";
import ApprovalWorkFlow from "../modules/approval-workflow/approval-work-flow";
import ApprovalList from "../modules/approval-workflow/approval-list";
import ApprovalAcceptance from "../modules/approval-workflow/approval-acceptance";
import MinMax from "../components/settings/min-max/min-max";
import BussinessCatalouge from "../components/settings/data-setup/bussiness-catalouge/bc-main-page";
import BussinessCatalougeCreate from "../components/settings/data-setup/bussiness-catalouge/bc-create-new";
// import { ipcRenderer } from "electron";

const Index = () => {
  // ipcRenderer.on("update_available", () => {
  //
  //   ipcRenderer.send("download-update");
  // });

  // ipcRenderer.on("update_downloaded", () => {
  //
  //   ipcRenderer.send("install-update");
  // });

  // Below commented line is for Desktop TPOS
  // const RouterComponent = isAdmin ? BrowserRouter : HashRouter;
  const RouterComponent = isAdmin ? BrowserRouter : BrowserRouter;

  return (
    <>
      <RouterComponent>
        <ErrorBoundary>
          <Routes>
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<MainLayout />}>
                {/* INVOICES */}
                <Route path="/" element={<Navigate to="/add-bill" />} />
                <Route path="/add-bill" element={<AddBilling />} />
                <Route path="/view-bill/:id" element={<ViewBilling />} />
                <Route path="/edit-bill/:id" element={<EditBilling />} />
                <Route path="/bills" element={<BillingTable />} />

                {/*----------------RETURN BILL-----------------*/}
                <Route path="/return-bills" element={<ReturnBillTable />} />
                <Route
                  path="/add-return-bill/:itemId/:type"
                  element={<AddReturnBill />}
                />
                <Route
                  path="/view-return-bill/:id"
                  element={<ViewReturnBill />}
                />
                <Route
                  path="/edit-return-bill/:id"
                  element={<EditReturnBilling />}
                />
                {/*----------------SALES ORDER-----------------*/}
                <Route path="/add-sales/:itemId/:type" element={<AddSales />} />
                <Route path="/sales" element={<SalesTable />} />
                <Route path="/view-sales/:id" element={<SalesOrderView />} />
                <Route path="/edit-sales/:id" element={<SalesOrderEdit />} />
                {/* SALES INVOICE */}
                <Route path="/sales-invoice" element={<SalesInvoice />} />
                <Route
                  path="/view-sales-invoice/:id"
                  element={<SalesInvoiceView />}
                />
                <Route
                  path="/edit-sales-invoice/:id"
                  element={<SalesInvoiceEdit />}
                />
                <Route
                  path="/add-sales-invoice/:itemId/:type"
                  element={<AddSalesInvoice />}
                />
                {/* SALES RETURN */}
                <Route path="/sales-return" element={<SalesReturn />} />
                <Route
                  path="/add-sales-return/:itemId/:type"
                  element={<AddSalesReturn />}
                />
                <Route
                  path="/view-sales-return/:id"
                  element={<SalesReturnView />}
                />
                <Route
                  path="/edit-sales-return/:id"
                  element={<SalesReturnEdit />}
                />
                {/* SALES CREDIT NOTE */}
                <Route
                  path="/sales-credit-note"
                  element={<SalesCreditNote />}
                />
                <Route
                  path="/add-sales-credit-note/:itemId/:type"
                  element={<AddSalesCreditNote />}
                />
                <Route
                  path="/view-sales-credit/:id"
                  element={<SalesCreditView />}
                />
                <Route
                  path="/edit-sales-credit/:id"
                  element={<SalesCreditEdit />}
                />
                {/* SALES PAYMENT IN */}
                <Route path="/sales-payment-in" element={<SalesPaymentIn />} />
                <Route
                  path="/add-sales-payment-in"
                  element={<AddSalesPaymentIn />}
                />
                <Route
                  path="/view-payment-in/:id"
                  element={<ViewPaymentIn />}
                />
                <Route
                  path="/Edit-payment-in/:id"
                  element={<EditPaymentIn />}
                />
                {/*Sales Delivery*/}
                <Route
                  path="/add-delivery/:itemId/:type"
                  element={<AddDelivery />}
                />
                <Route path="/view-delivery/:id" element={<ViewDelivery />} />
                <Route path="/edit-delivery/:id" element={<EditDelivery />} />
                <Route path="/sales-delivery" element={<SalesDeliveyTable />} />
                {/*----------------------------PURCHASE ORDER--------------------*/}
                <Route
                  path="/add-purchase/:itemId/:type"
                  element={<AddPurchase />}
                />
                <Route path="/purchase" element={<PurchaseTable />} />
                <Route path="/view-purchase/:id" element={<ViewPurchase />} />
                <Route path="/edit-purchase/:id" element={<EditPurchase />} />
                <Route
                  path="/purchase-order-csv"
                  element={<PurchaseOrderCsv />}
                />
                {/*GOODS RECEIPT*/}
                <Route
                  path="/goods-receipt/:itemId/:type"
                  element={<GoodsReceipt />}
                />

                <Route path="/view-goods/:id" element={<ViewGoodsReceipt />} />
                <Route path="/edit-goods/:id" element={<EditGoodsReceipt />} />
                <Route path="/goods" element={<GoodsTable />} />
                <Route path="/goods-receipt-csv" element={<GoodsOrderCsv />} />
                {/* PURCHASE INVOICE */}
                <Route
                  path="/purchase-invoice"
                  element={<PurchaseInvoiceTable />}
                />
                <Route
                  path="/add-purchase-invoice/:itemId/:type"
                  element={<AddPurchaseInvoice />}
                />
                <Route
                  path="/view-purchase-invoice/:id"
                  element={<ViewPurchaseInvoice />}
                />
                <Route
                  path="/edit-purchase-invoice/:id"
                  element={<EditPurchaseInvoice />}
                />
                {/* PURCHASE RETURN */}
                <Route
                  path="/purchase-return"
                  element={<PurchaseReturnTable />}
                />
                <Route
                  path="/add-purchase-return/:itemId/:type"
                  element={<AddPurchaseReturn />}
                />
                <Route
                  path="/view-purchase-return/:id"
                  element={<ViewPurchaseReturn />}
                />
                <Route
                  path="/edit-purchase-return/:id"
                  element={<EditPurchaseReturn />}
                />
                {/* PURCHASE CREDIT NOTE */}
                <Route
                  path="/purchase-credit"
                  element={<PurchaseCreditTable />}
                />
                <Route
                  path="/add-purchase-credit/:itemId/:type"
                  element={<AddPurchaseCredit />}
                />
                <Route
                  path="/view-purchase-credit/:id"
                  element={<ViewPurchaseCredit />}
                />
                <Route
                  path="/edit-purchase-credit/:id"
                  element={<EditPurchaseCredit />}
                />
                {/* PURCHASE PAYMENT OUT */}
                <Route
                  path="/purchase-payment-out"
                  element={<PurchasePaymentOut />}
                />
                <Route
                  path="/add-purchase-payment-out"
                  element={<AddPurchasePaymentOut />}
                />
                <Route
                  path="/view-payment-out/:id"
                  element={<ViewPaymentOut />}
                />
                <Route
                  path="/edit-payment-out/:id"
                  element={<EditPaymentOut />}
                />

                {/* BULK PURCHASE ORDER */}
                <Route
                  path="/bulk-purchase-order"
                  element={<BulkPurchaseOrder />}
                />
                {/* //CUSTOMER  */}
                <Route path="/add-customer" element={<AddCustomer />} />
                <Route path="/customer" element={<CustomerTable />} />
                <Route path="/view-customer/:id" element={<ViewCustomer />} />
                <Route path="/edit-customer/:id" element={<EditCustomer />} />
                {/* //DOCTOR  */}
                <Route path="/add-doctor" element={<AddDoctor />} />
                <Route path="/doctor" element={<DoctorTable />} />
                <Route path="/view-doctor/:id" element={<ViewDoctor />} />
                <Route path="/edit-doctor/:id" element={<EditDoctor />} />
                {/* //PRODUCT  */}
                <Route path="/add-product" element={<AddProduct />} />
                <Route path="/product" element={<ProductTable />} />
                <Route path="/view-product/:id" element={<ViewProduct />} />
                <Route path="/edit-product/:id" element={<EditProduct />} />
                {/* //STORE  */}
                <Route path="/add-store" element={<AddStore />} />
                <Route path="/store-information" element={<StoreTable />} />
                <Route path="/view-store/:id" element={<ViewStore />} />
                <Route path="/edit-store/:id" element={<EditStore />} />
                {/* //CUSTOMER  */}
                <Route path="/add-user" element={<AddUser />} />
                <Route path="/user" element={<UserTable />} />
                <Route path="/view-user/:id" element={<ViewUser />} />
                <Route path="/edit-user/:id" element={<EditUser />} />
                {/* //Discounts  */}
                <Route path="/price-list" element={<PriceListTable />} />
                <Route path="/add-price-list" element={<AddPriceList />} />
                <Route path="/discount-group" element={<DiscountGroup />} />
                <Route
                  path="/period-volume"
                  element={<PeriodVolumeDiscounts />}
                />
                <Route
                  path="/edit-price-list/:id"
                  element={<EditPriceList />}
                />
                {/* //Inventory  */}
                <Route path="/inventory" element={<InventoryBase />} />
                <Route path="/create-warehouse" element={<CreateWarehouse />} />
                <Route
                  path="/bin-location-management"
                  element={<BinLocationManagement />}
                />
                <Route
                  path="/regional-restrictions"
                  element={<RegionalRestrictionsTable />}
                />
                <Route
                  path="/add-regional-restriction"
                  element={<AddRegionalRestriction />}
                />
                <Route
                  path="/edit-regional-restriction/:id"
                  element={<AddRegionalRestriction />}
                />
                <Route
                  path="/view-regional-restriction/:id"
                  element={<ViewRegionalRestriction />}
                />

                {/* //CUSTOMER ADMIN  */}
                <Route
                  path="/admin/add-customer"
                  element={<AdminAddCustomern />}
                />
                {/* //TEMPERORY  */}

                <Route
                  path="/admin/add-customern"
                  element={<AdminAddCustomern />}
                />
                {/* //TEMPERORY  */}

                <Route
                  path="/edit-customer-admin/:id"
                  element={<AdminEditCustomer />}
                />

                <Route
                  path="/edit-customer-admin/:id/:adddressType"
                  element={<AdminEditCustomer />}
                />

                <Route
                  path="/admin/view-customer/:id"
                  element={<AdminViewCustomer />}
                />
                <Route
                  path="/admin/customer"
                  element={<AdminCustomerTable />}
                />
                {/* STORE TRANSFER */}
                <Route
                  path="/add-stock-transfer"
                  element={<AddStoreTransfer />}
                />
                <Route
                  path="/stock-transfer"
                  element={<StockTransferTable />}
                />
                <Route
                  path="/view-stock-transfer/:id"
                  element={<ViewStockTransfer />}
                />
                <Route
                  path="/edit-stock-transfer/:id"
                  element={<EditStockTransfer />}
                />
                {/* //CUSTOMER  */}
                <Route path="/under-dev/:page" element={<UnderDevelopment />} />
                {/* //STORE  */}
                <Route
                  path="/store-execution"
                  element={<StoreExecutionTable />}
                />
                <Route
                  path="/edit-store-execution/:id"
                  element={<EditStoreExecution />}
                />
                <Route
                  path="/view-store-execution/:id"
                  element={<ViewStoreExecution />}
                />
                {/* //Account  */}
                <Route path="/chart-of-account" element={<ChartOfAccount />} />
                <Route
                  path="/account-allocation"
                  element={<GlAccountAllocation />}
                />
                <Route path="/journal-entry/:id" element={<JournalEntry />} />
                <Route path="/journal-entry" element={<JournalTable />} />
                {/*--------------------------SETTINGS ---------------------------------------*/}
                <Route path="/add-alert" element={<AddAlert />} />
                <Route path="/view-alert/:id" element={<ViewAlert />} />
                <Route path="/edit-alert/:id" element={<EditAlert />} />
                <Route path="/alerts" element={<AlertTable />} />

                <Route path="/settings" element={<Settings />} />
                <Route
                  path="/settings/manufacturer-setup"
                  element={<ManufacturerSetup />}
                />
                <Route
                  path="/settings/shipping-setup"
                  element={<ShippingSetup />}
                />

                <Route path="/settings/uom-setup" element={<UnitOfMeasure />} />
                <Route
                  path="/settings/uom-group-setup"
                  element={<UomGroup />}
                />
                <Route
                  path="/settings/uom-group-setup/add"
                  element={<UomGroupAddEdit />}
                />
                <Route
                  path="/settings/uom-group-setup/edit/:id"
                  element={<UomGroupAddEdit />}
                />
                <Route path="/settings/item-setup" element={<ItemSetup />} />
                <Route path="/settings/tax-setup" element={<TaxSetup />} />
                {/* //new data setup  */}
                {/* temerory  */}

                <Route path="/temp" element={<AddressSidebar />} />
                {/* temerory  */}

                <Route
                  path="/settings/schedule-drug"
                  element={<ScheduleDrug />}
                />
                <Route path="/settings/pack-info" element={<PackInfo />} />
                <Route path="/settings/composition" element={<Composition />} />

                <Route path="/settings/lead" element={<Lead />} />
                <Route path="/settings/payment" element={<Payment />} />
                <Route path="/settings/party" element={<Party />} />
                <Route path="/settings/location" element={<Location />} />

                <Route
                  path="/settings/specialization"
                  element={<Specialization />}
                />
                <Route path="/settings/insurance" element={<Insurance />} />

                {/* //new data setup  */}

                <Route
                  path="/settings/tcs-tds-setup"
                  element={<TcsTdsSetup />}
                />
                <Route
                  path="/settings/customization"
                  element={<Customization />}
                />
                <Route
                  path="/settings/invoice-customization"
                  element={<InvoiceCustomization />}
                />
                <Route
                  path="/settings/department-and-role-setup"
                  element={<DepartmentAndRole />}
                />
                <Route
                  path="/settings/alternative-item-setup"
                  element={<AlternativeItemSetup />}
                />
                <Route
                  path="/settings/document-numbering-series"
                  element={<DocumentNumbering />}
                />
                <Route
                  path="/settings/custom-numbering-series"
                  element={<CustomDocumentNumbering />}
                />
                <Route
                  path="/settings/smtp-configuration"
                  element={<SmtpConfiguration />}
                />
                <Route
                  path="/settings/whatsapp-configuration"
                  element={<WhatsappConfiguration />}
                />
                <Route
                  path="/settings/sms-configuration"
                  element={<SmsConfiguration />}
                />
                <Route
                  path="/settings/razorpay-configuration"
                  element={<RazorPayConfiguration />}
                />
                <Route
                  path="/settings/stripe-configuration"
                  element={<StripeConfiguration />}
                />
                <Route
                  path="/settings/phonepe-configuration"
                  element={<PhonePeConfiguration />}
                />
                <Route
                  path="/settings/paytm-configuration"
                  element={<PaytmConfiguration />}
                />
                <Route
                  path="/settings/pine-labs-configuration"
                  element={<PineLabConfiguration />}
                />

                <Route
                  path="/settings/print-preference"
                  element={<PrintPreference />}
                />
                <Route
                  path="/settings/module-settings"
                  element={<ModuleSettings />}
                />

                <Route
                  path="/settings/import-templates"
                  element={<ImportTemplates />}
                />

                <Route
                  path="/settings/min-max"
                  element={<MinMax />}
                />

                <Route path="/approval-work-flow" element={<ApprovalWorkFlow/>}/>
                <Route path="/approval-work-flow/list" element={<ApprovalList/>}/>
                <Route path="/approval-work-flow/acceptance/:id" element={<ApprovalAcceptance/>}/>
                <Route path="/reports" element={<Reports />} />
                <Route path="/reports/savedReports" element={<SavedReport />} />
                <Route path="/settings/bussiness-catalouge" element={<BussinessCatalouge />} />
                <Route path="/settings/bussiness-catalouge/:type/:id?" element={<BussinessCatalougeCreate />} />
                <Route
                  path="/reports/sales/over-all"
                  element={<OverallSalesReport />}
                />

                <Route
                  path="/reports/sales/product-purchase-return"
                  element={<PurchaseAndReturnReport />}
                />

                <Route
                  path="/reports/sales/b2b-sales-summary"
                  element={<B2bSalesSummary />}
                />

                <Route
                  path="/reports/inventory/store-purchase"
                  element={<StorePurchase />}
                />

                <Route
                  path="/reports/sales/payment-mode-wise"
                  element={<PaymentModeWiseSalesReport />}
                />
                <Route
                  path="/reports/inventory/bounce"
                  element={<BounceReport />}
                />
                <Route
                  path="/reports/inventory/stock-sales"
                  element={<StockSalesReport />}
                />
                <Route
                  path="/reports/expiry-loss"
                  element={<ExpiryLossReport />}
                />
                <Route
                  path="/reports/customer-payable"
                  element={<CustomerPayable />}
                />
                <Route
                  path="/reports/productOrder"
                  element={<PurchaseOrder />}
                />
                <Route
                  path="/reports/product-info"
                  element={<ProductInfoReport />}
                />
                <Route path="/reports/profit" element={<ProfitReport />} />
                <Route
                  path="/reports/vendorMaster"
                  element={<VendorMaster />}
                />
                <Route
                  path="/reports/StockLedgerBatch"
                  element={<StockLedgerBatch />}
                />
                <Route
                  path="/reports/vendorPayable"
                  element={<VendorPayable />}
                />
                <Route path="/reports/dayWise" element={<DayWise />} />
                <Route
                  path="/reports/inventory/reorder"
                  element={<ReOrder />}
                />
                {/* Gst Reports */}
                <Route path="/reports/gstr-1" element={<Gstr1Report />} />
                <Route path="/reports/gstr-2a" element={<Gstr2aReport />} />
                <Route
                  path="/reports/hsn-code-summary"
                  element={<GstHsnCodeReport />}
                />
                <Route path="/reports/gstr-3b" element={<Gstr3bReport />} />
                <Route path="/reports/gstr-9" element={<Gstr9Report />} />
                <Route path="/reports/gstr-9c" element={<Gstr9cReport />} />
                <Route
                  path="/reports/gst-itc-mismatch"
                  element={<GstItcMisMatchReport />}
                />
                <Route
                  path="/reports/gst-e-way-bill"
                  element={<GstEwayBillReport />}
                />
                <Route
                  path="/reports/gst-payment-summary"
                  element={<GstPaymentSummaryReport />}
                />
                <Route
                  path="/reports/gst-itc-aging"
                  element={<GstItcAgingReport />}
                />
                {/*--------------------------DASHBOARD ---------------------------------------*/}

                <Route path="/old-dashboard" element={<DashBoard />} />
                <Route path="/dashboard" element={<NewDashboard />} />
                <Route path="/stock-details" element={<StockDetails />} />
                {/* //CUSTOMER  */}
                <Route path="/stock-audit" element={<StockAuditTable />} />
                <Route path="/add-audit" element={<AddStockAudit />} />
                <Route path="/view-audit/:id" element={<ViewStockAudit />} />
                <Route path="/edit-audit/:id" element={<EditStockAudit />} />
              </Route>
            </Route>
            {/* </Route> */}
            <Route element={<ProtectedRoute />}>
              <Route path="/login" element={<UserLogin />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<PasswordReset />} />
            </Route>
          </Routes>
        </ErrorBoundary>
        <ToastContainer limit={2} />
      </RouterComponent>
    </>
  );
};

export default Index;
